import {
  FULFILLMENT_STATUSES,
  ORDER_METHODS,
  PaymentMethods,
  REFUND_REASONS,
} from '../../../../../services/exports/Constants';
import { OFFER_KIND } from '../../../../../views/menu/offers/constants';

export default {
  title: 'Szczegóły zamówienia',
  sections: {
    driver_info: 'Informacje o kierowcy',
    order_info: 'Informacje o zamówieniu',
    price_info: 'Informacje o cenie',
    adjustments: 'Korekty',
  },
  order_methods: {
    [ORDER_METHODS.pickup]: 'Na wynos',
    [ORDER_METHODS.delivery]: 'Dostawa',
    [ORDER_METHODS.on_site]: 'Zamawianie przy stoliku',
  },
  fulfillment_statuses: {
    [FULFILLMENT_STATUSES.created]: 'To zamówienie oczekuje na zatwierdzenie',
    [FULFILLMENT_STATUSES.reviewed]: 'To zamówienie oczekuje na zatwierdzenie',
    [FULFILLMENT_STATUSES.accepted]: 'To zamówienie jest aktualnie przetwarzane',
    [FULFILLMENT_STATUSES.preparing]: 'To zamówienie jest aktualnie przetwarzane',
    [FULFILLMENT_STATUSES.ready]: 'To zamówienie jest gotowe do odbioru przez klienta',
    [FULFILLMENT_STATUSES.on_delivery]: 'To zamówienie jest dostarczane do klienta',
    [FULFILLMENT_STATUSES.picked]: 'To zamówienie zostało pomyślnie zrealizowane',
    [FULFILLMENT_STATUSES.rejected]: 'To zamówienie zostało odrzucone i zwrócone',
    default: 'To zamówienie zostało pomyślnie zrealizowane',
  },
  adjustment_reasons: {
    [REFUND_REASONS.RequestedByCustomer]: 'Na życzenie klienta',
    [REFUND_REASONS.Reclamation]: 'Reklamacja',
    [REFUND_REASONS.CommunicationError]: 'Błąd komunikacji',
    [REFUND_REASONS.Other]: 'Inne',
    [REFUND_REASONS.Dispute]: 'Spór klienta',
    dispute_win: 'Wygrany spór klienta',
    null: '',
    undefined: '',
  },
  labels: {
    // A table order's table: "Table 7"; names like "Terrace 2" show as they are.
    table_numbered: 'Stolik {{name}}',
    // Orders placed with Room/Table service before table ordering: the venue and the number typed.
    venue: 'Lokal',
    table_number: 'Numer stolika',
    order_note: 'Notatka do zamówienia',
    discount: 'Rabat',
    driver_name: 'Imię i nazwisko kierowcy',
    driver_phone_number: 'Telefon kierowcy',
    pin_code: 'PIN',
    invoice_payment: 'Płatność fakturą',
    paid_in_cash: 'Płatność gotówką',
    customer_paid_online: 'Klient zapłacił online',
    phone: 'Tel',
    email: 'E-mail',
    points_used: 'To zamówienie zawiera nagrodę za punkty lojalnościowe wykorzystaną przez stałego klienta',
    delivery: 'Dostawa',
    pickup: 'Odbiór',
    original: 'Oryginał',
    delivery_fee: 'Opłata za dostawę',
    tip: 'Napiwek',
    service_fee: 'Obsługa online',
    payment_method_upcharge_fee: {
      [PaymentMethods.PAYPAL]: 'Opłata PayPal',
    },
    discount_breakdown: {
      [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: 'Zastosowano rabat procentowy od sumy',
      [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: 'Zastosowano rabat procentowy od produktów',
      [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: 'Zastosowano rabat kwotowy od produktów',
      [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: 'Zastosowano rabat kwotowy od sumy',
      [OFFER_KIND.BOGO]: 'Zastosowano Bogo',
      [OFFER_KIND.BOGO_HALF_PRICE]: 'Zastosowano BOGO pół ceny',
      [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: 'Zastosowano darmowy produkt za produkty',
      [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: 'Zastosowano darmowy produkt za kwotę',
      GiftCard: 'Zastosowano kartę podarunkową',
      Reward: 'Zastosowano punkty lojalnościowe',
      CashbackAccount: 'Zastosowano punkty lojalnościowe',
      PromoCodeComponent: 'Zastosowano promocję',
      Offer: 'Zastosowano ofertę',
    },
    total_discount: 'Zastosowano promocję',
    tax: 'Podatki',
    total: 'Łącznie',
    today: 'Dzisiaj',
  },
  schedule: {
    header: 'Zaplanowano na {{date}}, {{time}}',
    text: 'Przypomnimy Ci, gdy nadejdzie czas przygotowania zamówienia',
  },
};
